import React, { Fragment } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Permission, checkPermission } from '../../../../_helpers';
import { BsThreeDotsVertical } from 'react-icons/bs';
import PermissionMessage from '../../Teams/PermissionMessage';

const SenderMessageThreeDots = ({
    m,
    rId,
    subChannelId,
    roomType,
    subChannelType,
    userRole,
    teamData,
    currUser,
    setReplyMessage,
    setEdit,
    edit,
    handleDeleteMessage,
    isForm,
    roomData,
}) => {
    return (
        <Dropdown className="dropper">
            <Dropdown.Toggle id="dropdown-basic" className="dropdown p-1">
                <div className="dropcss-sender">
                    <BsThreeDotsVertical color="#fff" size={18} />
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu">
                <Dropdown.Item onClick={() => setReplyMessage(m, { name: currUser.name })}>
                    {edit !== m.id && <span>Reply</span>}
                </Dropdown.Item>
                {roomType && (roomType === 'private' || roomType === 'public') && (
                    <Permission
                        role={currUser.role}
                        perform="edit:messagePermission"
                        yes={() => (
                            <PermissionMessage
                                message={m}
                                rId={rId}
                                editId={edit}
                                userRole={userRole}
                                teamData={teamData}
                                currUser={currUser}
                            />
                        )}
                        no={() => {
                            let userTeamRole = teamData?.role;
                            let isTeamRoleAuthorized = checkPermission(userTeamRole, 'edit:messagePermission');
                            let userChannel = currUser.roomList
                                .filter((room) => room.room)
                                .find((room) => room.room.id === rId);
                            let userChannelRole = (userChannel || {}).role;

                            let isChannelRoleAuthorized = false;
                            if (userChannelRole) {
                                isChannelRoleAuthorized = checkPermission(userChannelRole, 'edit:messagePermission');
                            }
                            let isEditPermissionAllowed = isTeamRoleAuthorized || isChannelRoleAuthorized;

                            if (isEditPermissionAllowed) {
                                return (
                                    <PermissionMessage
                                        message={m}
                                        rId={rId}
                                        editId={edit}
                                        userRole={userRole}
                                        teamData={teamData}
                                        currUser={currUser}
                                    />
                                );
                            }
                            return null;
                        }}
                    />
                )}
                {subChannelType && subChannelType === 'private' && (
                    <Permission
                        role={currUser.role}
                        perform="edit:messagePermission"
                        yes={() => (
                            <PermissionMessage
                                message={m}
                                subChannelId={subChannelId}
                                editId={edit}
                                userRole={userRole}
                            />
                        )}
                        no={() => {
                            let userRoomRole = roomData?.role;
                            let isRoomRoleAuthorized = checkPermission(userRoomRole, 'edit:messagePermission');
                            let userSubChannel = currUser.subChannelList
                                .filter((subChannel) => subChannel.subChannel)
                                .find((subChannel) => subChannel.subChannel.id === subChannelId);
                            let userSubChannelRole = (userSubChannel || {}).role;

                            let isSubChannelRoleAuthorized = false;
                            if (userSubChannelRole) {
                                isSubChannelRoleAuthorized = checkPermission(userRoomRole, 'edit:messagePermission');
                            }
                            let isEditPermissionAllowed = isRoomRoleAuthorized || isSubChannelRoleAuthorized;

                            if (isEditPermissionAllowed) {
                                return (
                                    <PermissionMessage
                                        message={m}
                                        subChannelId={subChannelId}
                                        editId={edit}
                                        userRole={userRole}
                                    />
                                );
                            }
                            return null;
                        }}
                    />
                )}

                {isForm && isForm.test(m.data) ? null : (
                    <Dropdown.Item onClick={() => setEdit((prev) => (prev ? '' : m.id))}>
                        <span>{edit === m.id ? 'Cancel' : 'Edit'}</span>
                    </Dropdown.Item>
                )}

                {edit !== m.id && (
                    <Fragment>
                        {subChannelId ? (
                            <Permission
                                role={currUser?.role}
                                perform="delete:message"
                                yes={() => (
                                    <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                        <span>Delete</span>
                                    </Dropdown.Item>
                                )}
                                no={() => {
                                    let userRoomRole = roomData?.role;
                                    let isRoomRoleAuthorized = checkPermission(userRoomRole, 'delete:message');
                                    let userSubChannel = currUser.subChannelList
                                        .filter((subChannel) => subChannel.subChannel)
                                        .find((subChannel) => subChannel.subChannel.id === rId);
                                    let userSubChannelRole = {
                                        owner: 'user',
                                        user: 'owner',
                                    }[(userSubChannel || {})?.role || 'owner'];

                                    let isSubChannelRoleAuthorized = false;
                                    if (userSubChannelRole) {
                                        isSubChannelRoleAuthorized = checkPermission(
                                            userSubChannelRole,
                                            'delete:message'
                                        );
                                    }
                                    let isDeleteAllowed = isRoomRoleAuthorized || isSubChannelRoleAuthorized;

                                    if (isDeleteAllowed) {
                                        return (
                                            <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                                <span>Delete</span>
                                            </Dropdown.Item>
                                        );
                                    }
                                    return null;
                                }}
                            />
                        ) : (
                            <Permission
                                role={currUser?.role}
                                perform="delete:message"
                                yes={() => (
                                    <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                        <span>Delete</span>
                                    </Dropdown.Item>
                                )}
                                no={() => {
                                    let userTeamRole = teamData?.role;
                                    let isTeamRoleAuthorized = checkPermission(userTeamRole, 'delete:message');
                                    let userChannel = currUser.roomList
                                        .filter((room) => room.room)
                                        .find((room) => room.room.id === rId);
                                    let userChannelRole = (userChannel || {}).role;

                                    let isChannelRoleAuthorized = false;
                                    if (userChannelRole) {
                                        isChannelRoleAuthorized = checkPermission(userChannelRole, 'delete:message');
                                    }
                                    let isDeleteAllowed = isTeamRoleAuthorized || isChannelRoleAuthorized;

                                    if (isDeleteAllowed) {
                                        return (
                                            <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                                <span>Delete</span>
                                            </Dropdown.Item>
                                        );
                                    }

                                    return isForm && !isForm.test(m.data) ? (
                                        <Dropdown.Item onClick={() => handleDeleteMessage(m.id)}>
                                            <span>Delete</span>
                                        </Dropdown.Item>
                                    ) : null;
                                }}
                            />
                        )}
                    </Fragment>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default SenderMessageThreeDots;
